import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  resourceVideos: [],
  success: false,
  error: null,
};

const resourceVideosReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_RESOURCE_VIDEO_REQUEST:
    case actionTypes.UPDATE_RESOURCE_VIDEO_REQUEST:
    case actionTypes.DELETE_RESOURCE_VIDEO_REQUEST:
    case actionTypes.READ_RESOURCE_VIDEO_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    /* SAVE */
    case actionTypes.SAVE_RESOURCE_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        resourceVideos: [...state.resourceVideos, action.payload],
      };

    /* UPDATE */
    case actionTypes.UPDATE_RESOURCE_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        resourceVideos: state.resourceVideos.map((item) =>
          item.resourceVideoObjId === action.payload.resourceVideoObjId
            ? action.payload
            : item
        ),
      };

    /* DELETE */
    case actionTypes.DELETE_RESOURCE_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        resourceVideos: state.resourceVideos.filter(
          (item) => item.resourceVideoObjId !== action.payload.resourceVideoObjId
        ),
      };

    /* READ */
    case actionTypes.READ_RESOURCE_VIDEO_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        resourceVideos: action.payload,
      };

    /* FAILURES */
    case actionTypes.SAVE_RESOURCE_VIDEO_FAILURE:
    case actionTypes.UPDATE_RESOURCE_VIDEO_FAILURE:
    case actionTypes.DELETE_RESOURCE_VIDEO_FAILURE:
    case actionTypes.READ_RESOURCE_VIDEO_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default resourceVideosReducer;
